import React, { useEffect, useState } from "react";
import {
  Modal,
  Form,
  Input,
  Col,
  Row,
  message,
  Select,
  InputNumber,
  DatePicker,
  Button,
  Space,
} from "antd";
import {
  API_METHODS,
  BLANK_VALUE,
  DEFAULT_DATE_FORMAT,
} from "../../../constants";
import useApi from "../../../hooks/useApi";
import {
  displayFormattedDate,
  formatDateToDayJS,
  getBanks,
  getClientConfig,
  getDebtors,
  getTrueOrFalseFromZeroAndOne,
  isEmpty,
  replaceBlankValueToUndefined,
} from "../../../generalFunctions";
import dayjs from "dayjs";
import TableComponent from "../../common/table/TableComponent";
import { useLocation, useNavigate } from "react-router-dom";
import { RightOutlined, LeftOutlined } from "@ant-design/icons";

function AddReceipt() {
  const location = useLocation();
  const innerColumns = [
    {
      title: "Bill Number",
      dataIndex: "id",
    },
    {
      title: "Invoice Date",
      dataIndex: "invoiceDate",
      render: (text) => displayFormattedDate(text),
    },
    {
      title: "Bill Amount",
      dataIndex: "finalBillAmount",
    },
    {
      title: "Balance Amount",
      dataIndex: "balanceAmount",
    },
    //chequeNumber
  ];
  const outerColumns = [
    {
      title: "Bill Number",
      dataIndex: "id",
    },
    {
      title: "Invoice Date",
      dataIndex: "invoiceDate",
      render: (text) => displayFormattedDate(text),
    },
    {
      title: "Bill Amount",
      dataIndex: "finalBillAmount",
    },
    {
      title: "Balance Amount",
      dataIndex: "balanceAmount",
    },
    {
      title: "Paid Amount",
      dataIndex: "paymentAmount",
      render: (text, record) => (
        <Input
          placeholder="Payment Amount"
          defaultValue={
            record.paymentAmount ? record.paymentAmount : record.balanceAmount
          }
          onChange={(e) => paymentAmountChanged(e, record)}
        ></Input>
      ),
      width: 150,
    },
    {
      title: "Action",
      key: "action",

      render: (text, record) => (
        <Space>
          <Button size="small" onClick={() => deleteRecord(record)}>
            Delete
          </Button>
        </Space>
      ),
    },
  ];
  const { account, voucherType } = getClientConfig();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [form] = Form.useForm();
  const [visible, setVisible] = useState();
  const [innerTableData, setInnerTableData] = useState();
  const [outerTableData, setOuterTableData] = useState();
  const [billData, setBillData] = useState();
  const [inititalVals, setInitialVals] = useState();
  const [loadingSaveButton, setLoadingSaveButton] = useState(false);

  const navigate = useNavigate();

  const [response, request] = useApi("/receipt", null, API_METHODS.POST);
  const [responseData, getRequest] = useApi(
    "/partyBill/receiptNotDone",
    null,
    API_METHODS.GET
  );
  const [receiptData, getReceiptData] = useApi(
    "/receipt/",
    null,
    API_METHODS.GET
  );

  const [editResponse, editRequest] = useApi(
    "/receipt",
    null,
    API_METHODS.POST
  );

  useEffect(() => {
    getRequest();
  }, []);

  useEffect(() => {
    if (location.state && location.state.receipt_id) {
      getReceiptData(
        null,
        API_METHODS.GET,
        `/receipt/${location.state.receipt_id}`
      );
    }
  }, [location.state]);

  useEffect(() => {
    const data = responseData.data !== BLANK_VALUE ? responseData.data : [];
    setBillData(data);
  }, [responseData]);

  useEffect(() => {
    if (response.data) {
      setLoadingSaveButton(false);
      message.success("Receipt added successfully.");
      navigate("/portal/receipt");
    }
  }, [response]);

  useEffect(() => {
    let initialValues = receiptData && receiptData.data && receiptData.data[0];
    if (initialValues) {
      initialValues = replaceBlankValueToUndefined(initialValues);
      initialValues.received = getTrueOrFalseFromZeroAndOne(
        initialValues.received
      );
      initialValues.receiptDate = formatDateToDayJS(initialValues.receiptDate);
      if (initialValues.chequeDate) {
        initialValues.chequeDate = formatDateToDayJS(initialValues.chequeDate);
      }

      form.setFieldsValue(initialValues);
      let data = [];
      //billData is bills for which receipt is not done

      data =
        billData &&
        billData.length > 0 &&
        billData.filter(
          (billData) => billData.billForId === initialValues.receiptForId
        );

      setInnerTableData(data);
      setInitialVals(initialValues);
      if (!isEmpty(initialValues.billData)) {
        setOuterTableData(initialValues.billData);
        let keys = [];
        for (let i = 0; i < initialValues.billData.length; i++) {
          keys.push(initialValues.billData[i].id);
        }
        setSelectedRows(initialValues.billData);
        setSelectedRowKeys(keys);
      }
    } else if (receiptData.error) {
      navigate("/portal/receipt");
    }
  }, [receiptData]);
  useEffect(() => {
    if (editResponse.data) {
      setLoadingSaveButton(false);
      message.success("Receipt updated successfully.");
      navigate("/portal/receipt");
    }
  }, [editResponse]);

  const paymentAmountChanged = (e, record) => {
    let amount = 0;
    let newOuterTableData = [...outerTableData];
    newOuterTableData.forEach(function (outerTableRecord) {
      if (outerTableRecord.id === record.id) {
        outerTableRecord.paymentAmount = Number(e.target.value);
      }
    });
    for (let i = 0; i < newOuterTableData.length; i++) {
      amount =
        amount +
        (newOuterTableData[i].paymentAmount
          ? newOuterTableData[i].paymentAmount
          : newOuterTableData[i].balanceAmount);
    }
    form.setFieldsValue({
      amount: amount,
    });
    setOuterTableData(newOuterTableData);
  };

  const deleteRecord = (record) => {
    const selectedBills = outerTableData.filter((bill) => bill !== record);
    let amount = form.getFieldValue("amount");
    let newSelectedRowKeys = selectedRowKeys;

    const index = newSelectedRowKeys.indexOf(record.id);
    if (index > -1) {
      newSelectedRowKeys.splice(index, 1);
    }

    amount =
      amount -
      (record.paymentAmount ? record.paymentAmount : record.balanceAmount);
    form.setFieldsValue({ amount });
    setOuterTableData(selectedBills);
    setSelectedRowKeys(newSelectedRowKeys);
    setSelectedRows(selectedBills);
  };

  const receiptForChanged = (receiptForId) => {
    const data = (billData || []).filter((bill) => bill.billForId === receiptForId);
    if (location.state && receiptForId === inititalVals.receiptForId) {
      if (inititalVals.billData) {
        let keys = [];
        for (let i = 0; i < inititalVals.billData.length; i++) {
          keys.push(inititalVals.billData[i].id);
        }
        setOuterTableData(inititalVals.billData);
        setSelectedRows(inititalVals.billData);
        setSelectedRowKeys(keys);
      }
      form.setFieldsValue(inititalVals);
    } else {
      setOuterTableData();
      setSelectedRows([]);
      setSelectedRowKeys([]);
      form.resetFields();
    }
    form.setFieldValue("receiptForId", receiptForId);
    setInnerTableData(data);
  };

  const onFinish = () => {
    form.validateFields().then((values) => {
      if (!loadingSaveButton) {
        setLoadingSaveButton(true);
        values.receiptDate = formatDateToDayJS(values.receiptDate);
        if (values.chequeDate) {
          values.chequeDate = formatDateToDayJS(values.chequeDate);
        }
        if (outerTableData && outerTableData.length > 0) {
          values.billIds = outerTableData.map((bill) => ({
            id: bill.id,
            paymentAmount: bill.paymentAmount
              ? bill.paymentAmount
              : bill.balanceAmount,
          }));
        }
        if (location && location.state) {
          editRequest(
            values,
            API_METHODS.PUT,
            `/receipt/${location.state.receipt_id}`
          );
        } else {
          request(values, API_METHODS.POST);
        }
      }
    });
  };

  const billsSelected = () => {
    let amount = 0;
    let newSelectedRows = [...selectedRows];
    if (!isEmpty(outerTableData)) {
      newSelectedRows = [...new Set([...outerTableData, ...selectedRows])];
    }
    for (let i = 0; i < newSelectedRows.length; i++) {
      if (newSelectedRows[i].paymentAmount) {
        amount = amount + newSelectedRows[i].paymentAmount;
      } else {
        amount = amount + newSelectedRows[i].balanceAmount;
      }
    }

    form.setFieldsValue({ amount });
    setOuterTableData(newSelectedRows);
    setVisible(false);
  };
  const onRowSelectChange = (newSelectedRowKeys, records) => {
    setSelectedRowKeys(newSelectedRowKeys);
    setSelectedRows(records);
  };

  const rowSelection = {
    selectedRowKeys,
    type: "checkbox",
    onChange: onRowSelectChange,
  };

  const setModalVisible = () => {
    setVisible(true);
  };

  const cancel = () => {
    setVisible(false);
  };

  const previousButtonClicked = () => {
    let receipt_id = form.getFieldValue("id") - 1;
    getReceiptData(null, API_METHODS.GET, `/receipt/${receipt_id}`);
  };
  const nextButtonClicked = () => {
    let receipt_id = form.getFieldValue("id") + 1;
    getReceiptData(null, API_METHODS.GET, `/receipt/${receipt_id}`);
  };

  return (
    <div>
      <Form
        layout="vertical"
        form={form}
        initialValues={{
          receiptDate: dayjs(),
          received: true,
        }}
        onFinish={onFinish}
        disabled={location && location.state && location.state.isViewOnly}
      >
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item name="id" label="Receipt Number">
              <Input disabled={true} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="receiptDate"
              label="Receipt Date"
              rules={[{ required: true, message: "Receipt Date is required." }]}
            >
              <DatePicker format={DEFAULT_DATE_FORMAT} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="receiptForId"
              label="Receipt For"
              rules={[{ required: true, message: "Receipt For is required." }]}
            >
              <Select
                allowClear
                showSearch
                disabled={!billData}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                onSelect={receiptForChanged}
              >
                {getDebtors(account).map((option) => (
                  <Select.Option key={option.id} value={option.id}>
                    {option.accountName}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="receiptTypeId"
              label="Receipt Type"
              rules={[{ required: true, message: "Receipt Type is required." }]}
            >
              <Select
                allowClear
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {voucherType.map((option) => (
                  <Select.Option key={option.id} value={option.id}>
                    {option.type}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        {form.getFieldValue("receiptForId") &&
          innerTableData &&
          innerTableData.length > 0 && (
          <Button type="primary" onClick={setModalVisible}>
            Select Party Bills
          </Button>
        )}
        {outerTableData && outerTableData.length > 0 && (
          <TableComponent
            columns={outerColumns}
            tableData={outerTableData}
            clientSideRender={true}
          />
        )}
        <Modal
          title="Select Party Bills"
          open={visible}
          onOk={billsSelected}
          onCancel={cancel}
          width={1000}
          okText="Save"
          destroyOnClose={true}
        >
          <TableComponent
            columns={innerColumns}
            tableData={innerTableData}
            rowSelection={rowSelection}
            clientSideRender={true}
          />
        </Modal>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              name="narration"
              label="Narration"
              rules={[
                { required: true, message: "Narration is required." },
                {
                  max: 100,
                  message: "Narration should be maximum of 100 characters.",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="received" label="Received Amount">
              <Select
                options={[
                  {
                    value: true,
                    label: "Yes",
                  },
                  {
                    value: false,
                    label: "No",
                  },
                ]}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="bankId" label="Bank">
              <Select
                allowClear
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {getBanks(account).map((option) => (
                  <Select.Option key={option.id} value={option.id}>
                    {option.accountName}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              label="Amount"
              name="amount"
              rules={[{ required: true, message: "Amount is required." }]}
            >
              <InputNumber
              // disabled={
              //   (location && location.state && location.state.isViewOnly) ||
              //   selectedRowKeys.length !== 0
              // }
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="chequeNumber"
              label="Cheque Number"
              rules={[
                {
                  max: 50,
                  message: "Cheque Number should be maximum of 50 characters.",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item name="chequeDate" label="Cheque Date">
              <DatePicker format={DEFAULT_DATE_FORMAT} />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item label="TDS Amount" name="tds">
              <InputNumber />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Bank Commision" name="bankCommision">
              <InputNumber />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                loading={loadingSaveButton}
              >
                Save
              </Button>
            </Form.Item>
          </Col>
          <Col>
            <Button
              type="primary"
              onClick={() => {
                navigate("/portal/receipt");
              }}
              disabled={false}
            >
              {location && location.state && location.state.isViewOnly
                ? "Close"
                : "Cancel"}
            </Button>
          </Col>
        </Row>
      </Form>
      {location && location.state && location.state.isViewOnly && (
        <Row justify="space-between">
          <Button type="primary" onClick={previousButtonClicked}>
            <LeftOutlined />
            Previous
          </Button>
          <Button type="primary" onClick={nextButtonClicked}>
            Next
            <RightOutlined />
          </Button>
        </Row>
      )}
    </div>
  );
}

export default AddReceipt;
